// @ts-nocheck
import React from "react";
import { Box } from "src/components/Core/Box";
import AccountItem from "./AccountItem";

interface Props {
  accounts: Array<any>;
  index: number;
  setIndex: (value: number) => void;
  accountId?: number;
}

const AccountList: React.FC<Props> = ({
  accounts,
  index,
  setIndex,
  accountId,
}) => {
  return (
    <Box background="white">
      {accounts.map((account, i) => (
        <AccountItem
          key={i}
          account={account}
          isActive={i === index ? true : false}
          setIndex={value => setIndex(value)}
          index={i}
          isShowOtherAcountText={
            i === 0 && accountId && (accounts || []).length > 1 ? true : false
          }
        />
      ))}
    </Box>
  );
};

export default AccountList;
